import BaseCrudService from './baseCrud.service'

class ProjectService extends BaseCrudService {
  constructor () {
    super('project', {
      id: false,
      name: '',
      details: '',
      address: '',
      zip: '',
      city: '',
      more: '',
      equipment: '',
      latitude: '',
      longitude: '',
      apartments: [],
      files: [],
      status: 1,
      created_by: 1,
      transfer_tax: 6.5,
      on_dashboard: 0,
      logo: {}
    })
  }

  getBought (userId, ...callbacks) {
    return this.constructor.get(this.endpoints().getBought.replace('{:userId}', userId), {}, ...callbacks)
  }

  attachFiles (itemId, data, ...callbacks) {
    return this.constructor.post(this.endpoints().attachFiles.replace('{:id}', itemId), data, ...callbacks)
  }

  detachFiles (itemId, filesIds, ...callbacks) {
    return this.constructor.post(
      this.endpoints().detachFiles.replace('{:id}', itemId),
      { 'filesIds': filesIds },
      ...callbacks
    )
  }

  attachImages (itemId, data, ...callbacks) {
    return this.constructor.post(this.endpoints().attachImages.replace('{:id}', itemId), data, ...callbacks)
  }

  setAccess (itemId, data, ...callbacks) {
    return this.constructor.post(this.endpoints().setAccess.replace('{:id}', itemId), data, ...callbacks)
  }
}

export default ProjectService
